module.exports = __webpack_public_path__ + "img/vpc17.daedd8a.png";